<template>
  <div>
    <div class="searchbox">
      <form action="#" method="get" class="form-inline form-float" @submit.prevent>
        <!-- <div class="form-group">
          <label for>手机号</label>
          <input
            v-model="search.mobile"
            class="form-control"
            id
            type="text"
            placeholder
            size="12"
            v-noBlankSpace
          />
        </div>
        <div class="form-group">
          <label for="bdate">时间</label>
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            :editable="false"
            v-model="search.startTime"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </div>
        <div class="form-group">
          <label for="edate">至</label>
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            :editable="false"
            v-model="search.endTime"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </div> -->
        <div class="form-group others">
          <span class="search_btn">
            <el-button
              @click="searchList"
              type="primary"
              :loading="loading"
               size="small"
            >
              查询
            </el-button>
          </span>
          <span class="add_btn">
            <button
              type="button"
              class="btn btn-default"
              id="add"
              @click="add()"
            >
              添加
            </button>
          </span>
        </div>
      </form>
    </div>

    <div class="list-right">
      <el-table
        ref="table"
        border
        :data="tableListData.rows"
        height="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        v-loading="loading"
      >
        <el-table-column
          show-overflow-tooltip
          label="url"
          prop="url"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="开始时间"
          prop="startTime"
        >
        </el-table-column>
        <el-table-column show-overflow-tooltip label="结束时间" prop="endTime">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="排序" prop="sequence">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="图片">
          <template slot-scope="scope">
            <img :src="scope.row.picUrl" width="40px" height="auto" />
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" width="200px">
          <template slot-scope="scope">
            <button
              class="edit"
              title="修改"
              href="javascript:;"
              @click="edit(scope.row)"
            >
              修改
            </button>
            <button
              class="delete"
              title="删除"
              href="javascript:;"
              @click="del(scope.row.id)"
            >
              删除
            </button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <component :is="currentComponent" @func="emptyComponent" :editData="editData"></component>
    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import { fetchAdvertisementPage, editOneAdvertisement } from "@/api/url";

import AddPopup from "./components/addPopup.vue";

import editPopup from "./components/editPopup.vue";

import Page from "../../commons/page";

export default {
  data() {
    return {
      loading: false,
      currentComponent: "",
      userlist_btn_delete: false,
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        userName: "",
        mobile: "",

        startTime: "",
        endTime: "",
      },
      editData:null,
      tableListData: {},

      formLabelWidth: "100px",
      dialogFormVisible: false,
      allType: [
        {
          label: "普通用户",
          value: "0",
        },
        {
          label: "管理员用户",
          value: "1",
        },
      ],
      form: {
        id: "",
        userName: "",
        type: "0",
      },
      rules: {
        userName: [
          { required: true, message: "请填写场景名称", trigger: "blur" },
          {
            min: 3,
            max: 12,
            message: "长度在 3 到 12 个字符",
            trigger: "blur",
          },
        ],
        type: [{ required: false, message: "请填写场景名称", trigger: "blur" }],
      },

      dialogFormVisiblePhoto: false,

      allImgUrl: [],
      plateNum: "",
      imgUrl: "",
      pageObj:{}
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    tableList: function (curPage) {
      this.loading = true;
      this.$get(fetchAdvertisementPage(), {
        // name: this.search.userName,
        // mobile: this.search.mobile,
        limit: this.search.pageSize,
        page: curPage,
        // beginTime: this.search.startTime,
        // endTime: this.search.endTime,
      }).then((data) => {
        if (data.status !== 200) {
          this.loading = false;
          return;
        }
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        // this.getPage(pageObj);
        this.pageObj={...pageObj}
        this.tableListData = data.data;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
        });
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    searchList: function () {
      var flTime = this.timeCompare(this.search.startTime, this.search.endTime);
      if (flTime) {
        return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      } else if (
        !Boolean(this.search.startTime) &&
        Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择开始时间", { time: 1 });
      } else if (
        Boolean(this.search.startTime) &&
        !Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择结束时间", { time: 1 });
      }

      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    timeCompare: function (bDateVal, eDateVal) {
      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }
      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      if (bdate - edate > 0) {
        return true;
      } else {
        return false;
      }
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.userName = "";
      this.search.mobile = "";
      this.search.startTime = "";
      this.search.endTime = "";
    },
    add() {
      this.currentComponent = "add-popup";
    },
    edit(row) {
      this.editData=row;
      this.currentComponent = "edit-popup";
    },
    del: function (id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除？",
        {
          btn: ["确定", "取消"],
          shade: true,
        },
        function () {
          _this.$layer.close(index);

          _this.$deleteRequest(editOneAdvertisement() + "/" + id).then((data) => {
            if (data.status != 200)
              return _this.$layer.msg("删除失败", { time: 1 });
            _this.tableList(_this.search.pageNumber);
          });
        }
      );
    },
    emptyComponent(m) {
      if (m === "add") {
        this.search.pageNumber = "1";
      }
      if (m === "add" || m === "edit" || m === "del") {
        this.tableList(this.search.pageNumber);
      }
      this.currentComponent = "";
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      this.userlist_btn_delete = this.elements["userlist:btn_delete"];
    },
  },
  components: {
    Page,
    AddPopup,
    editPopup,
  },
  created: function () {
    this.permiss;
  },
  mounted: function () {
    this.tableList(this.search.pageNumber);
  },
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
</style>